import { insetObjectTable } from '../../utils/utils'
import {
  OPTIMISER_DRIVER_GET,
  OPTIMISER_DRIVER_GET_SUCCESS,
  OPTIMISER_DRIVER_GET_FAILURE,
  GET_DRIVER_WARRNING,
  GET_DRIVER_WARRNING_SUCCESS,
  GET_DRIVER_WARRNING_FAILURE,
  GET_DRIVER_WARRNING_MORE_SUCCESS,
  GET_DRIVER_WARRNING_MORE_FAILURE,
  GET_DRIVERS_POLARIS,
  GET_DRIVERS_POLARIS_SUCCESS,
  GET_DRIVERS_POLARIS_FAILURE,
  GET_DRIVERS_POLARIS_LIST_MORE,
  GET_DRIVERS_POLARIS_LIST_MORE_SUCCESS,
  GET_DRIVERS_POLARIS_LIST_MORE_FAILURE,
  PAGE_CHANGED_DRIVERS,
  PAGE_LIMIT_CHANGED_DRIVERS,
  SEARCH_CHANGED_DRIVERS,
  ADD_DRIVER_POLARIS,
  ADD_DRIVER_POLARIS_SUCCESS,
  ADD_DRIVER_POLARIS_FAILURE,
  UPDATE_DRIVER_POLARIS,
  UPDATE_DRIVER_POLARIS_SUCCESS,
  UPDATE_DRIVER_POLARIS_FAILURE,
  REMOVE_ERROR_DRIVERS,
  RESET_SUCCESS_ACTION_DRIVERS,
  RESET_CONFIG_DRIVERS,
} from './actionsConsts'
import initialState from './initialState'

export default (state = initialState(), action) => {
  if (action.type === OPTIMISER_DRIVER_GET) {
    return {
      ...state,
      driversOptimiser: [],
      isLoadingDriversOptimiser: true,
    }
  }

  if (action.type === OPTIMISER_DRIVER_GET_SUCCESS) {
    const { drivers, count } = action.payload.data
    return {
      ...state,
      driversOptimiser: drivers,
      driversOptimiserCount: count,
      isLoadingDriversOptimiser: false,
    }
  }

  if (action.type === OPTIMISER_DRIVER_GET_FAILURE) {
    return {
      ...state,
      isLoadingDriversOptimiser: false,
    }
  }

  if (action.type === GET_DRIVER_WARRNING) {
    return {
      ...state,
      drivers: [],
      driversOptimiserCount: 0,
      isLoadingDriversOptimiser: true,
    }
  }

  if (action.type === GET_DRIVER_WARRNING_SUCCESS) {
    const { drivers, count } = action.payload.data
    return {
      ...state,
      drivers: drivers,
      driversOptimiserCount: count,
      isLoadingDriversOptimiser: false,
    }
  }

  if (action.type === GET_DRIVER_WARRNING_MORE_SUCCESS) {
    const { drivers, count } = action.payload.data
    return {
      ...state,
      drivers: [...state.drivers, ...drivers],
      driversOptimiserCount: count,
      isLoadingDriversOptimiser: false,
    }
  }

  if (
    action.type === GET_DRIVER_WARRNING_FAILURE ||
    action.type === GET_DRIVER_WARRNING_MORE_FAILURE
  ) {
    return {
      ...state,
      isLoadingDriversOptimiser: false,
    }
  }

  if (action.type === GET_DRIVERS_POLARIS) {
    return {
      ...state,
      driversSettings: [],
      isLoadingDriversSettingsList: true,
    }
  }

  if (action.type === GET_DRIVERS_POLARIS_SUCCESS) {
    const { data, count } = action.payload.data
    return {
      ...state,
      driversSettings: data,
      isLoadingDriversSettingsList: false,
      driversSettingsCount: count,
    }
  }

  if (action.type === GET_DRIVERS_POLARIS_FAILURE) {
    const { response } = action.payload?.data
    return {
      ...state,
      isLoadingDriversSettingsList: false,
      errorMessage: response?.data?.message || ' Veuillez réessayer plus tard ',
      isErrorFetch: true,
    }
  }

  if (action.type === GET_DRIVERS_POLARIS_LIST_MORE) {
    return {
      ...state,
    }
  }
  if (action.type === GET_DRIVERS_POLARIS_LIST_MORE_SUCCESS) {
    return {
      ...state,
      driversSettings: [...state.driversSettings, ...action.payload?.data?.data],
      driversSettingsCount: action.payload.data?.count || 0,
    }
  }

  if (action.type === GET_DRIVERS_POLARIS_LIST_MORE_FAILURE) {
    const { response } = action.payload?.data
    return {
      ...state,
      errorMessage: response?.data?.message || ' Veuillez réessayer plus tard ',
    }
  }

  if (action.type === PAGE_CHANGED_DRIVERS) {
    const { offset } = action.payload
    const filter = { ...state.filter }
    filter.offset = offset
    return {
      ...state,
      filter,
    }
  }

  if (action.type === PAGE_LIMIT_CHANGED_DRIVERS) {
    const { limit } = action.payload
    const filter = { ...state.filter }
    filter.limit = limit
    filter.offset = 0
    return {
      ...state,
      filter,
    }
  }

  if (action.type === SEARCH_CHANGED_DRIVERS) {
    const { search } = action.payload
    return {
      ...state,
      filter: {
        ...state.filter,
        actif: true,
        limit: 25,
        offset: 0,
        query: search,
      },
    }
  }

  if (action.type === ADD_DRIVER_POLARIS) {
    return {
      ...state,
      isLoadingDriverSettingsAction: true,
    }
  }
  if (action.type === ADD_DRIVER_POLARIS_SUCCESS) {
    return {
      ...state,
      isLoadingDriverSettingsAction: false,
      success: true,
      isSuccessRefresh: true,
    }
  }

  if (action.type === ADD_DRIVER_POLARIS_FAILURE) {
    const { response } = action.payload.data
    return {
      ...state,
      isLoadingDriverSettingsAction: false,
      errorMessage: response?.data?.message || ' Veuillez réessayer plus tard ',
    }
  }

  if (action.type === UPDATE_DRIVER_POLARIS) {
    return {
      ...state,
      isLoadingDriverSettingsAction: true,
    }
  }
  if (action.type === UPDATE_DRIVER_POLARIS_SUCCESS) {
    const { data } = action.payload.data
    const driverSettingsIndex = state.driversSettings
      .map((el) => el.id)
      .indexOf(data.id)

    return {
      ...state,
      driversSettings: [
        ...insetObjectTable(state.driversSettings, data, driverSettingsIndex),
      ],
      isLoadingDriverSettingsAction: false,
      success: true,
    }
  }

  if (action.type === UPDATE_DRIVER_POLARIS_FAILURE) {
    const { response } = action.payload?.data
    return {
      ...state,
      isLoadingDriverSettingsAction: false,
      success: false,
      errorMessage: response?.data?.message || ' Veuillez réessayer plus tard ',
    }
  }

  if (action.type === REMOVE_ERROR_DRIVERS) {
    return {
      ...state,
      errorMessage: null,
      isErrorFetch: false,
    }
  }

  if (action.type === RESET_SUCCESS_ACTION_DRIVERS) {
    return {
      ...state,
      success: false,
      isSuccessRefresh: false,
    }
  }

  if (action.type === RESET_CONFIG_DRIVERS) {
    //rest
    return {
      ...state,
      errorMessage: null,
      isErrorFetch: false,
      isLoadingDriverSettingsAction: false,
      success: false,
      isSuccessRefresh: false,

      filter: {
        limit: 25,
        offset: 0,
        actif: true,
      },
    }
  }

  return state
}
